import isEmpty from 'lodash/isEmpty';
import isString from 'lodash/isString';
import Communication from './Communication';
import Navigation from './Navigation';
import Session from './Session';
import Util from './Util';

/**
 * Contains utilities for Auth0
 */
class Auth0Util {
	static isEligibleForAuth0() {
		const {
			isInWebStore,
			IsInWinClient,
			EnableAuth0ForSafari,
			UseAuth0SignIn,
		} = Session.getSettings();
		const { isSso } = Session.getCalculatedSettings();
		const isSafari = Util.getBrowser(true) === 'Safari' ? true : false;
		const UseAuth0ForSafari = EnableAuth0ForSafari === true && isSafari;

		if (
			UseAuth0SignIn === true &&
			!IsInWinClient &&
			!isInWebStore &&
			!isSso &&
			(UseAuth0ForSafari || !isSafari)
		) {
			return true;
		}

		return false;
	}

	static async launchSignInPage() {
		let appName = Util.getQueryParamByName('app_name');
		const additionalInfo = {};
		const isAuth0CustomError = Util.getQueryParamByName('error') || '';

		const appContext = Util.getCookie('appcontext');

		if (!isEmpty(isAuth0CustomError) && appContext) {
			appName = appContext;
		}

		const isAuth0Winclient = appName
			? appName.toLowerCase().indexOf('winclient') !== -1
			: false;
		const isAuth0Mobile = appName
			? appName.toLowerCase().indexOf('mobile') !== -1
			: false;

		if (!isEmpty(isAuth0CustomError) || isAuth0Winclient || isAuth0Mobile) {
			/**
			 * The clientId is passed in the query string for Return To Login Button functionality
			 * This case covers Winclient and Mobile context for Auth0 custom error page, Forgot Username and Password
			 */
			const clientId = Util.getQueryParamByName('client_id') || '';
			additionalInfo.queryString = `auth0ClientId=${clientId}&appContext=${appName}`;
		} else {
			// remove any query params that are not needed
			Util.removeQueryParamByName([
				'app_name',
				'client_id',
				'login_redirect_uri',
			]);

			const domain = window.location.hostname;
			const redirectToStamps =
				domain === 'endicia.com' ||
				domain === 'endicia.dev' ||
				domain.endsWith('.endicia.com') ||
				domain.endsWith('.endicia.dev');
			let returnToPage = window.location.href;

			// replace the domain name to use stamps
			if (redirectToStamps) {
				const newDomain = domain
					.replace('endicia.com', 'stamps.com')
					.replace('endicia.dev', 'stamps.dev');
				returnToPage = window.location.href.replace(domain, newDomain);
			}

			additionalInfo.queryString = `returnTo=${returnToPage}`;
		}

		await Navigation.navigateTo('signin', additionalInfo);
	}

	static async completeAuth() {
		const code = Util.getQueryParamByName('code');
		const state = Util.getQueryParamByName('state');

		const responseObj = {
			isSuccessful: false,
			url: '',
		};

		if (isString(code) && isString(state)) {
			const completeAuthResponse = await Communication.completeAuth({
				code,
				state,
			});
			const url = completeAuthResponse?.data?.url || '';

			if (Communication.isSuccessful(completeAuthResponse) && !isEmpty(url)) {
				const time = new Date(new Date().getTime() + 90 * 86400000);
				Util.setCookie('existingcust', 'true', time, '/');

				responseObj.isSuccessful = true;
				responseObj.url = url;
			}
		}

		return responseObj;
	}

	static async signOut() {
		await Navigation.navigateTo('signout');
	}
}

export default Auth0Util;
